<script setup lang="ts">
import { useAppStore } from '@/store/app/app'
import { useToggleStore } from '@/store/toggle/toggle'

import { Category } from '@/types/api/api-v3/category'

type Props = {
  category: Category
}

const props = defineProps<Props>()

const route = useRoute()

const appStore = useAppStore()
const { isLandingPageEnabled } = useToggleStore()

const isActiveCategory = computed(() => {
  return isLandingPageEnabled
    ? appStore.activeCategorySlug === props.category.slug
    : route.params.category === props.category.slug
})
</script>

<template>
  <a
    class="menu-categories-link"
    :class="{ 'menu-categories-link--active': isActiveCategory }"
  >
    {{ category.name }}
  </a>
</template>

<style scoped lang="scss">
.menu-categories-link {
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  color: var(--ui-text-primary);
  cursor: pointer;

  &--active {
    color: var(--ui-primary);
  }
}
</style>
